module.exports = __webpack_public_path__ + "static/CLASSROOM0-851f15dda58af1dd0d42f79bda567eda.jpg";